import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { H2 } from 'components/core/Typography';
import { Review } from 'components/review/Review';
import { ReviewList } from 'components/review/ReviewList';
import { StarReview } from 'components/review/StarReview';
import { ReviewSummary } from 'components/review/ReviewSummary';

import './facilityReviews.scss';


export function FacilityReviews({
	facilityId,
	ratingCounts,
	pros,
	cons,
	reviews,
	reviewAverage,
	reviewCount,
	className,
	recommendedRate,
	facilityUrl,
	fullFacilityUrl,
	currentReviewPage,
	images,
	facilityName,
	locationText
}) {
	return (
		<div id="reviews" className={classnames(className, 'facility-reviews-v1')}>
			{reviewCount > 0 &&
				<div className="reviews-header">
					<H2 size="large">
						Customer reviews
					</H2>
					<StarReview
						outOf={5}
						rating={reviewAverage}
						reviewCount={reviewCount}
						starSize="small"
						showOutOf
					/>
				</div>
			}
			<div className="reviews-row">
				{reviewCount > 0 &&
					<div className="left-col">
						<ReviewList
							facilityUrl={facilityUrl}
							fullFacilityUrl={fullFacilityUrl}
							currentPage={currentReviewPage}
						>
							{reviews.map((review) => (
								<Review
									key={review.id}
									id={review.id}
									reviewerName={review.nickname}
									reviewTitle={review.title}
									reviewText={review.message}
									reviewDate={new Date(review.date.format.iso)}
									reviewRating={review.rating}
									reviewRatingOutOf={5}
									priceRating={review.ratingDetails.ratingPrice}
									serviceRating={review.ratingDetails.ratingService}
									cleanlinessRating={review.ratingDetails.ratingCleanliness}
									recommended={review.ratingRecommended}
									managerResponse={review.managerResponse}
									images={images}
									facilityName={facilityName}
									address={locationText}
								/>
							))}
						</ReviewList>
					</div>
				}
				<div className="right-col">
					<ReviewSummary
						ratingCounts={ratingCounts}
						totalReviews={reviewCount}
						pros={pros}
						cons={cons}
						recommendedRate={recommendedRate}
						facilityId={facilityId}
					/>
				</div>
			</div>
		</div>
	);
}

FacilityReviews.propTypes = {
	reviews: PropTypes.arrayOf(PropTypes.object),
	reviewAverage: PropTypes.number,
	reviewCount: PropTypes.number.isRequired,
	ratingCounts: PropTypes.arrayOf(PropTypes.shape({
		rating: PropTypes.number.isRequired,
		count: PropTypes.number.isRequired
	})).isRequired,
	pros: PropTypes.arrayOf(PropTypes.object),
	cons: PropTypes.arrayOf(PropTypes.object),
	facilityId: PropTypes.number.isRequired,
	facilityUrl: PropTypes.string.isRequired,
	fullFacilityUrl: PropTypes.string.isRequired,
	recommendedRate: PropTypes.number,
	currentReviewPage: PropTypes.number,
	className: PropTypes.string,
	images: PropTypes.arrayOf(PropTypes.string),
	facilityName: PropTypes.string
};

export default FacilityReviews;
